// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionTitle_container__1OGNs","Title":"QuestionTitle_Title__1rL41","Type":"QuestionTitle_Type__vb1xg","Source":"QuestionTitle_Source__1IKFG"};